import React, {Suspense} from "react";
import OurPlusTabs from "../../../components/OurPlusTabs";
import {useTranslation} from "react-i18next";

export default function  OurPlus() {

    const {t } = useTranslation();

    const OurPlusTabsGrid = [
        {
            icon: "/images/our_plus_1.svg",
            tabsNumber: "01",
            title: t("our_plus.title.1"),
            description: t("our_plus.description.1"),
        },
        {
            icon: "/images/our_plus_2.svg",
            tabsNumber: "02",
            title: t("our_plus.title.2"),
            description: t("our_plus.description.2"),
        },
        {
            icon: "/images/our_plus_3.svg",
            tabsNumber: "03",
            title: t("our_plus.title.3"),
            description: t("our_plus.description.3"),
        },
        {
            icon: "/images/our_plus_4.svg",
            tabsNumber: "04",
            title: t("our_plus.title.4"),
            description: t("our_plus.description.4"),
        },
    ];

    return (
        <>
            <section id="OurPlus">
                <div className="flex flex-col items-center px-6 md:px-5 sm:px-[16px]">
                    <div className="container-xs flex flex-col items-start gap-7">
                        <div className="grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-5 sm:gap-2 self-stretch">
                            <Suspense fallback={<div>Loading </div>}>
                                {OurPlusTabsGrid.map((d, index) => (
                                    <OurPlusTabs {...d} key={"grid" + index}/>
                                ))}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}